module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2fa"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("INTRODUCTION")]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_c('span', {
    staticClass: "co"
  }, [_vm._v("D")])]), _vm._v("ear Friends,")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("There are many books out there on how to raise special children. This one is about raising up the parents.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Some of you are just joining us with a new diagnosis. We know how scary and overwhelming that time can be. Some of you are starting to find your way and are learning how to navigate the medical world and school system. Some of you are veterans and have been loving and serving your child with special needs for a very long time. But we all have something in common: our children. They were fearfully and wonderfully made in the image of God (Gen. 1:27; Ps. 139:13–16). They are changing our lives, and the lives of those around us, every day.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Just as you pour yourselves into your children, we want to pour hope and courage back into you. We want to refresh your spirit by speaking biblical truth directly to the unique aspects of your particular lifestyle. As you read this book, you’ll meet dozens of other parents on a journey similar to yours, whose children represent a wide variety of physical and mental challenges. Know this, dear friend: you are not alone. Regardless of which particular diagnoses are mentioned in "), _c('i', [_vm._v("Refresh")]), _vm._v(", the struggles and joys borne out of them are ones you can relate to. We want you to meet the parents who share their stories here, but most importantly, we want you to meet Jesus within the pages of "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("this book. The message of hope is the thread that binds these stories all together.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("That message is the person and work of Jesus Christ. We hope and pray you know him personally already. If you don’t, or if you’re unsure, please refer to “Knowing Jesus Personally” in the back of the book. For those who already have a relationship with Christ, we pray that this book will be a great encouragement to you in your walk with him. Whether your faith is dormant or flourishing today, know that we’ve been praying for you for years. God longs to meet with you, no matter where you are on the journey.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("As you read through these devotions, ask God to be with you and to open your heart to his Word and his Holy Spirit. After each devotional there is a prayer you can pray and a series of questions. Take the time to really think about how you would respond. We encourage you to journal your thoughts. If God is working in your heart or teaching you something new about himself, share it with your spouse or a close friend.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("We echo the heart of Paul in his letter to the Colossian church: “My goal is that they may be encouraged in heart and united in love, so that they may have the full riches of complete understanding, in order that they may know the mystery of God, namely, Christ, in whom are hidden all the treasures of wisdom and knowledge” (Col. 2:2–3).")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("God is always at work. These pages are a testament to the work he is doing in the lives of everyone who participated in any part of this devotional. From all of us to all of you: feel loved, be encouraged, pursue Christ, press on.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("With sincere love and gratitude,")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Kimberly M. Drew and Jocelyn Green")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46afe7d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Introduction.vue
// module id = 78
// module chunks = 0